import sysLocalStorage, { enStorageName } from '@/store/localStorage'
import { GetterTree, ActionTree, MutationTree, Module } from 'vuex'
import { RootState } from '@/store/types'
import ass_logo from '@/assets/logo.png'
import { tryToStr } from '@/configs/functions'

export interface AppState {
    device: string,
    sidebar: { opened: boolean, withoutAnimation: boolean },
    logo: string,
    webStyle: string//系统样式版本
}
const hiddenSidebar = enStorageName[enStorageName.HiddenSidebar]
const snStyleVer = 'StyleVersion'
export const state: AppState = {
    sidebar: {
        opened: !+sysLocalStorage.getItem(hiddenSidebar),
        withoutAnimation: false
    },
    device: 'desktop',
    logo: ass_logo,
    webStyle: tryToStr(sysLocalStorage.getItem(snStyleVer))
}

const mutations: MutationTree<AppState> = {
    SET_WEBSTYLE: (mState, webStyle) => {
        mState.webStyle = webStyle
        sysLocalStorage.setItem(snStyleVer, webStyle)
    },
    TOGGLE_SIDEBAR: (mState: AppState) => {
        if (mState.sidebar.opened) {
            sysLocalStorage.setItem(hiddenSidebar, '1')
        } else {
            sysLocalStorage.setItem(hiddenSidebar, '0')
        }
        mState.sidebar.opened = !mState.sidebar.opened
        mState.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (mState, withoutAnimation) => {
        sysLocalStorage.setItem(hiddenSidebar, '1')
        mState.sidebar.opened = false
        mState.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (mState, device) => {
        mState.device = device
    }
}

const actions: ActionTree<AppState, RootState> = {
    ToggleSideBar: ({ commit }) => {
        commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
        commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
        commit('TOGGLE_DEVICE', device)
    },
    SetWebStyle({ commit }, webStyle) {
        commit('SET_WEBSTYLE', webStyle)
    }
}

const getters: GetterTree<AppState, RootState> = {
    sidebar: mState => mState.sidebar,
    device: mState => mState.device,
    logo: mState => mState.logo,
    webStyle: mState => mState.webStyle
}

const namespaced: boolean = true;

export const app: Module<AppState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
